import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { PieChartIcon } from 'lucide-react';
import { SoftCard } from '../components';
export const CompletionRate = ({ completionRateData, currentCompletionRate, brandColors, CustomTooltip }) => {
    return (React.createElement(SoftCard, { header: {
            title: "Form Completion Rate",
            subtitle: "Weekly form completion rates over time"
        }, footer: {
            children: (React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("div", { className: "flex items-center text-sm text-gray-600" },
                    React.createElement(PieChartIcon, { className: "w-4 h-4 mr-1 text-orange-500" }),
                    "Current completion rate: ",
                    currentCompletionRate.toFixed(1),
                    "%")))
        } },
        React.createElement("div", { className: "h-64" },
            React.createElement(ResponsiveContainer, { width: "100%", height: "100%" },
                React.createElement(LineChart, { data: completionRateData, margin: {
                        top: 20,
                        right: 30,
                        left: 20,
                        bottom: 5
                    } },
                    React.createElement(CartesianGrid, { strokeDasharray: "3 3" }),
                    React.createElement(XAxis, { dataKey: "name" }),
                    React.createElement(YAxis, { domain: [0, 100], tickFormatter: tick => `${tick}%` }),
                    React.createElement(Tooltip, { content: React.createElement(CustomTooltip, { active: false, payload: [], label: "" }) }),
                    React.createElement(Line, { type: "monotone", dataKey: "rate", name: "Completion Rate", stroke: brandColors.primary, strokeWidth: 2, dot: {
                            r: 4,
                            fill: brandColors.primary
                        }, activeDot: {
                            r: 6
                        } }))))));
};
export default CompletionRate;
